// src/lib/supabaseClient.ts
import { createClient, type SupabaseClient } from '@supabase/supabase-js'

const SUPABASE_URL = import.meta.env?.VITE_SUPABASE_URL
const SUPABASE_KEY = import.meta.env?.VITE_SUPABASE_ANON_KEY

let supabase: SupabaseClient

if (!SUPABASE_URL || !SUPABASE_KEY) {
  console.warn('[supabaseClient] Missing Supabase environment variables. Supabase client disabled.')
  supabase = {
    from() {
      throw new Error('[supabaseClient] Missing Supabase environment variables.')
    },
    auth: {
      async getSession() {
        throw new Error('[supabaseClient] Missing Supabase environment variables.')
      },
      async getUser() {
        throw new Error('[supabaseClient] Missing Supabase environment variables.')
      }
    }
  } as unknown as SupabaseClient
} else {
  // Single shared client instance
  supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
    global: {
      // Older app versions require the original strict note response shape.
      headers: { 'x-storyteller-note-format': '2' },
    },
  })
}

export { supabase }
